import Vue from 'vue'
import router from '@/router'
import api from '@/api/index'
import config from '@/config/index'
import utils from '@/utils'
import vd from '@/utils/globalVar'
import rules from '@/utils/validations'
import handling from '@/api/error'
import { saveCookie, getCookie, removeCookie } from '../cookies.js'
import {
  LOGIN_SUCCESS,
  LOGIN_AUTH_REQUIRED,
  LOGOUT_SUCCESS,
  GETUSERINFO_SUCCESS,
  ORG_UPDATE,
  GETROLES_SUCCESS
} from '../types'
var failure = handling.failureHandling
var state = {
  token: getCookie('token') || null,
  user: getCookie('user') || null,
  org: getCookie('org') || null, // 用户当前机构
  roles: null, // 用户当前角色
  login_auth_required: ''
}
const actions = {
  getCode (store, phone) { // 获取手机验证码
    api.get(config.bylBaseCenterPath, '/login/phone/code', {
      phone: phone
    }, function (r) { // 获取正常
      Vue.toasted.show('获取验证码成功')
    })
  },
  codeLogin (store, f) { // 验证码登录
    api.post(config.bylBaseCenterPath, '/login/phone', {
      orgId: '',
      phone: f.phone,
      verify: f.code,
      loginType: '2'
    }, function (r) { // 登录正常
      // 登录后后台已将user信息返回
      saveCookie('token', r.data.token) // 保存登录状态
      vd.setVal('$TOKEN_VAL', r.data.token) // 设置Vue的全局变量
      store.commit(LOGIN_SUCCESS, r.data)
      r.data.user.roleList = r.data.roleList // 获取到用户的权限信息,赋值到user上
      store.dispatch('saveUserInfo', r.data.user) // 本地localStorage保存用户信息(不包括机构信息)
      store.commit(GETUSERINFO_SUCCESS, r.data.user) // Vuex更新user(不包括机构信息)
      if (utils.getQueryString('h')) {
        window.location.href = window.location.origin + '/' + decodeURIComponent(utils.getQueryString('h')) + '?domain=' + utils.getQueryString('domain')
      } else {
        router.push({path: '/byl/index'})
      }
      // store.dispatch('frLogin', r.data.token)
    })
  },
  localLogin (store, user) {  // 手机号/邮箱/工号 + 密码登录
    var type = null
    if (rules.cellphone.pattern.test(user.accountName)) {
      type = '2'
    } else if (rules.email.pattern.test(user.accountName)) {
      type = '3'
    } else {
      type = '1'
    }
    api.post(config.bylBaseCenterPath, '/login/username', {
      accountName: user.accountName,
      password: user.password,
      verify: user.verify,
      type: type,
      loginType: '2' // PC端登录
    }, function (r) { // 登录正常
      saveCookie('token', r.data.token) // 保存登录状态
      vd.setVal('$TOKEN_VAL', r.data.token) // 设置Vue的全局变量
      store.commit(LOGIN_SUCCESS, r.data)
      r.data.user.roleList = r.data.roleList // 获取到用户的权限信息,赋值到user上
      store.dispatch('saveUserInfo', r.data.user) // 本地localStorage保存用户信息(不包括机构信息)
      store.commit(GETUSERINFO_SUCCESS, r.data.user) // Vuex更新user(不包括机构信息)
      if (utils.getQueryString('h')) {
        window.location.href = window.location.origin + '/' + decodeURIComponent(utils.getQueryString('h')) + '?domain=' + utils.getQueryString('domain')
      } else {
        router.push({path: '/byl/index'})
      }
      // store.dispatch('frLogin', r.data.token)
    }, function (r) { // 登录异常
      failure(r)
      if (r == 'USER_ERROR_00002' || r == 'USER_ERROR_00003') {
        store.dispatch('getPicCode')
      }
    })
  },
  frLogin (store, token) {
    var scr = document.createElement("iframe"); // 创建iframe
    var scr1 = document.createElement("iframe"); // 创建iframe
    scr.id = 'fr-iframe';
    scr1.id = 'fr-success-iframe';
    // console.log(config.domains[0])
    // console.log(config.webport)
    scr.src = "http://218.80.205.234:8079" + "/WebReport/ReportServer?op=fs_load&cmd=sso&fr_username=" + "GUEST" + "&fr_password=" + token;
    scr.style.display = 'none';
    scr1.style.display = 'none';
    document.body.appendChild(scr);
    document.body.appendChild(scr1);
    if (scr.attachEvent) {       // 判断是否为ie浏览器
      scr.attachEvent("onload", function () {
        scr1.src  = "http://218.80.205.234:8079/WebReport/ReportServer?op=fs" // 直接跳转到数据决策系统
      });
    } else {
      scr.onload = function () {
        scr1.src  = "http://218.80.205.234:8079/WebReport/ReportServer?op=fs" // 直接跳转到数据决策系统
        // window.location.href = "http://218.80.205.234:8079/WebReport/ReportServer?op=fs"
      };
    }
  },
  getPicCode (store) { // 手机号/邮箱/工号 + 密码输错三次后需要获取图片验证码
    api.get(config.bylBaseCenterPath, '/login/code', null, function (r) {
      store.commit(LOGIN_AUTH_REQUIRED, r.data)
    })
  },
  clearLoginAuth (store) {
    store.commit(LOGIN_AUTH_REQUIRED, false)
  },
  frLogout (store) {
    api.get(config.bylBaseCenterPath, '/logoutByFinereport', null, function (r) { // 登出正常
      document.body.removeChild(document.getElementById('fr-iframe'));
      document.body.removeChild(document.getElementById('fr-success-iframe'))
    })
  },
  logout ({commit, dispatch, rootState}) {
    function act () {
      removeCookie('token') // 清除token 及 cookie
      vd.setVal('$TOKEN_VAL', '') // 设置Vue的全局变量
      removeCookie('user') // 清除user
      removeCookie('pool') // 清除下拉框
      removeCookie('ifrm_031')
      removeCookie('query_record')
      commit(LOGOUT_SUCCESS)
      Vue.toasted.show('登出成功')
      dispatch('toOtherDomain', getCookie('org')) // 登出以后的跳转
      removeCookie('org') // 清除机构
      dispatch('frLogout')
    }
    api.get(config.bylBaseCenterPath, '/user/logout', null, function (r) { // 登出正常
      act()
    }, function (r) {
      // 登出异常
      if (r.message == 'US_ERROR_00002') {
        act()
      } else {
        Vue.toasted.show(r)
      }
    })
  },
  getOrgs (store, user) { // 获取用户所属机构
    api.post(config.bylApiPath, '/entInfo/searchByUser', {
      pageNo: '1',
      pageSize: '100'
    }, function (r) { // 获取正常
      user.orgs = r.data
      store.dispatch('saveUserInfo', user) // 本地保存用户信息
      store.commit(GETUSERINFO_SUCCESS, user) // 更新state
      if (user.orgs) {
        var idx = utils.findElem(user.orgs, 'domain',  utils.getQueryString('domain') + '.byl.sh.cn') // 寻找当前机构下标
      }
      if (idx > -1) {
        store.dispatch('updateOrg', user.orgs[idx])
      } else {
        if (user.orgs) {
          let index = utils.findElem(user.orgs, 'domain', config.DEFAULT_DOMAIN) // 设置成默认的域名 'inesa.byl.sh.cn'
          store.dispatch('updateOrg', user.orgs[index])
        }
      }
    })
  },
  saveUserInfo (store, user) {
    saveCookie('user', JSON.stringify(user))
  },
  saveOrg (store, org) {
    saveCookie('org', JSON.stringify(org))
  },
  updateOrg (store, org) {
    store.commit(ORG_UPDATE, org)
    store.dispatch('saveOrg', org) // 更新cookies里保存的当前机构
  },
  setCurrentOrg (store, org) { // 设置当前机构
    store.commit(ORG_UPDATE, org)
    store.dispatch('saveOrg', org) // 更新cookies里保存的当前机构
    store.dispatch('toOtherDomain', org) // 跳转
  },
  toOtherDomain (store, org) { // 不同机构的切换，以及手动输入domain后的跳转
    var dev = false;
    if (window.location.hostname == 'localhost') {
      dev = true;
    }
    var isIP = utils.isIP(window.location.hostname);
    // var actualDomain = (isIP) ? DEFAULT_ADDRESS : org.domain;
    // var actualDomain = (isIP) ? window.location.hostname : org.domain;
    var actualDomain = (isIP) ? window.location.hostname : window.location.hostname;
    var actualPort = (config.DEPLOY) ? '' : config.webport
    if (dev) { // 开发状态下用vue router路由
      if (org.businessId == '1') { // 职称教育
        router.push({path: '/continueEdu/home'})
      } else if (org.businessId == '2') { // 安全教育
        router.push({path: '/byl/index'})
      } else if (org.businessId == '3') { // 企业内训
        router.push({path: '/entrain/home'})
      } else if (org.businessId == '4') { // 党建教育
        router.push({path: '/byl/index'})
      } else {
        router.push({path: '/byl/index'})
      }
    } else {
      var d2 = org.domain.replace('.byl.sh.cn', '') // 获取到域名（code）
      if (org.businessId == '1') { // 职称教育
        // 如果用域名, 用org.domain
        window.location.href = 'http://' +  actualDomain + ':' + actualPort + '/#/continueEdu/home?domain=' + d2
      } else if (org.businessId == '2') { // 安全教育
        window.location.href = 'http://' +  actualDomain + ':' + actualPort + '/#/byl/index'
      } else if (org.businessId == '3') { // 企业内训
        window.location.href = 'http://' +  actualDomain  + ':' + actualPort + '/#/entrain/home?domain=' + d2
      } else if (org.businessId == '4') { // 党建教育
        window.location.href = 'http://' +  actualDomain  + ':' + actualPort + '/#/byl/index'
      } else { //
        window.location.href = 'http://' + actualDomain + ':' + actualPort + '/#/byl/index'
      }
    }
    if (org.toRefresh) { // 解决到首页后，页面有缓存导致header显示问题，需要强刷一下
      var targetUrl = utils.delQueryString(window.location.href, 'expired')
      window.location.href = targetUrl;
      window.location.reload()
    }
  },
  updates (store, f) { // 更新token与用户信息
    saveCookie('token', f.token) // 保存登录状态
    store.commit(LOGIN_SUCCESS, f)
  },
  getRoles (store) { // 取当前登录用户的角色信息
    api.post(config.bylBaseCenterPath, '/user/role/roles', null, function (r) { // 获取正常
      store.commit(GETROLES_SUCCESS, r.data) // 更新state
    })
  },
  hasMemberByUserId (store, userId) {
      var that = this
      return new Promise(function (resolve, reject) {
        api.post(config.bylApiPath, '/member/by/user', {userId: userId}, r => {
          resolve(!!r.data)
        })
      })
  },
  getMemberByUserId (store, userId) {
    var that = this
    return new Promise(function (resolve, reject) {
      api.post(config.bylApiPath, '/member/by/user', {userId: userId}, r => {
        resolve(r.data)
      })
    })
  },
  getBusinessIdByCode (store, code) {
    var that = this
    return new Promise(function (resolve, reject) {
      api.post(config.bylApiPath, '/entBusiness/searchByCode', {code: code}, r => {
        resolve(r.data)
      })
    })
  }
}
const mutations = {
  [LOGIN_SUCCESS] (state, action) {
    state.token = action.token
  },
  [LOGIN_AUTH_REQUIRED] (state, action) {
    state.login_auth_required = action
  },
  [LOGOUT_SUCCESS] (state) {
    state.token = null
    state.user = null
  },
  [GETUSERINFO_SUCCESS] (state, action) {
    state.user = action
  },
  [ORG_UPDATE] (state, action) {
    state.org = action
  },
  [GETROLES_SUCCESS] (state, action) {
    state.roles = action
  }
}

const getters = {
  getToken: state => {
    return state.token || undefined
  },
  getCurrentOrg: state => {
    if (state.user && state.user.orgs) {
      return state.org
    } else {
      return {}
    }
  },
  getCurrentRoles: state => {
    if (state.roles) {
      return state.roles
    } else {
      return []
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js